import './NewsPageElementCss/NewsMainSection.css'
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AnimatedText from "../../AnimatedText"
import {getNotification} from "../../api/api"
import CustomLoader from '../../common/loader/CustomLoader'

export default function NewsMainSection() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState("");
    const [notification, setNotification] = useState([]);

    useEffect(() => {
        fetchNotification();
    }, []);
    
    const fetchNotification = async () => {
        const payload = {};
        try {
            setLoading(true);
            const res = await getNotification(payload);
            if (res?.data?.status === "succesful") {
                const apiData = res?.data?.userdata || [];
        
                if (apiData.length > 0) {
                    setNotification(apiData);
                    setMessage("");
                } else {
                    setNotification([]);
                    setMessage("No data found");
                }
            } else {
                setNotification([]);
                setMessage("Problem on API");
            }
        
            console.log("res.data===>", res?.data);
        } catch (error) {
            console.error("Error fetching notification data:", error);
        } finally {
            setLoading(false);
        }
    };

    // Handle click to navigate to detail page
    const handleNewsClick = (news) => {
        // navigate(/news/${newsId});
        // navigate(/news/${news.id}, { state: { news } });
        navigate('/news/details', { state: { news } });
    };

    console.log("notification==>", notification);

    return(
        <div className="NewsMainContainer">
            <div className="ourPackageUpperSection">
                <AnimatedText
                    tag="h2"
                    type="words"
                    y={30}
                    className="rb-title ourpackageTitle"
                >
                    News
                </AnimatedText>
            </div>

            {loading ? <CustomLoader/>
             : message ? (
                <div className="messageContainer">
                    <p>{message}</p>
                </div>
            ) : (
                <div className="newsGridContainer">
                    {notification.map((news) => (
                        <div 
                            key={news.id} 
                            className="newsCard"
                            onClick={() => handleNewsClick(news)}
                        >
                            <div className="newsImageWrapper">
                                <img 
                                    src={news.Notification_Image} 
                                    alt={news.Notification_Title} 
                                    className="newsImage" 
                                />
                            </div>
                            <div className="newsContent">
                                <p className="newsTitle">{news.Notification_Title}</p>
                                <p className="newsDescription">{news.Notification_Body}</p>
                               
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    )
}